import React from "react";
import { slugify } from "../../../utils/helpers";

export const Newsletter = props => {
  const { field, value, handleChange, fieldId } = props;
  const { type, name, label, placeholder, required, className, options, labelPlacement, layoutGridColumnSpan, description } = field;
  const columnClass = `col-span-${layoutGridColumnSpan}`;
  return (
    <div
      className={`newsletter-field${name ? " active" : ""}${required ? " required" : ""} ${labelPlacement} ${columnClass}`}
    >
      <div className="checkboxes">
        <label htmlFor={fieldId} className="checkbox">
          <input
            name={name}
            id={fieldId}
            checked={value[name] ? true : false}
            type="checkbox"
            onChange={handleChange}
            value="yes"
          />
          {label}
        </label>
      </div>
      {description && (<p className="description">{description}</p>)}
    </div>
  );
};
